import './bootstrap';

document.addEventListener('DOMContentLoaded', async () => {
    const consentPanel = document.querySelector('[data-consent-panel]');
    document.querySelectorAll('[data-consent-open]').forEach((button) => button.addEventListener('click', () => {
        consentPanel?.removeAttribute('hidden');
        consentPanel?.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }));

    const marketing = window.marketingTracking;
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content;
    if (marketing) {
        document.querySelectorAll('[data-marketing-event]').forEach(async (element) => {
            const marker = `marketing:${element.dataset.marketingEvent}:${element.dataset.planId || location.pathname}`;
            if (sessionStorage.getItem(marker)) return;
            sessionStorage.setItem(marker, '1');
            const payload = { name: element.dataset.marketingEvent, event_id: crypto.randomUUID?.(), plan_id: Number(element.dataset.planId) || null };
            try {
                await fetch(marketing.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-CSRF-TOKEN': csrf }, body: JSON.stringify(payload), keepalive: true });
            } catch {}
        });

        const purchase = document.querySelector('[data-marketing-purchase]');
        if (purchase) {
            const eventId = purchase.dataset.eventId;
            const value = Number(purchase.dataset.value);
            const currency = purchase.dataset.currency;
            const order = purchase.dataset.order;
            if (window.gtag) {
                window.gtag('event', 'purchase', { transaction_id: order, value, currency });
                if (marketing.adsId && marketing.adsLabel) window.gtag('event', 'conversion', { send_to: `${marketing.adsId}/${marketing.adsLabel}`, transaction_id: order, value, currency });
            }
            if (marketing.meta && window.fbq) window.fbq('track', 'Purchase', { value, currency, order_id: order }, { eventID: eventId });
            if (marketing.tiktok && window.ttq) window.ttq.track('CompletePayment', { value, currency, order_id: order }, { event_id: eventId });
        }
    }

    const button = document.querySelector('[data-menu-toggle]');
    const menu = document.querySelector('[data-mobile-menu]');

    document.querySelectorAll('[data-countdown]').forEach((element) => {
        const end = new Date(element.dataset.countdown).getTime();
        const render = () => {
            const seconds = Math.max(0, Math.floor((end - Date.now()) / 1000));
            const days = Math.floor(seconds / 86400);
            const hours = Math.floor((seconds % 86400) / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            element.textContent = seconds > 0 ? `Ends in ${days ? `${days}d ` : ''}${hours}h ${minutes}m` : 'Offer ended';
        };
        render();
        window.setInterval(render, 60000);
    });

    button?.addEventListener('click', () => {
        const willOpen = menu.hasAttribute('hidden');
        menu.toggleAttribute('hidden');
        button.setAttribute('aria-expanded', String(willOpen));
    });

    const adminSidebar = document.querySelector('[data-admin-sidebar]');
    const adminBackdrop = document.querySelector('[data-admin-backdrop]');
    const setAdminMenu = (open) => {
        adminSidebar?.classList.toggle('is-open', open);
        adminBackdrop?.toggleAttribute('hidden', !open);
        document.body.classList.toggle('overflow-hidden', open);
    };
    document.querySelector('[data-admin-open]')?.addEventListener('click', () => setAdminMenu(true));
    document.querySelector('[data-admin-close]')?.addEventListener('click', () => setAdminMenu(false));
    adminBackdrop?.addEventListener('click', () => setAdminMenu(false));

    document.querySelectorAll('[data-auto-submit]').forEach((element) => {
        element.addEventListener('change', () => element.form?.requestSubmit());
    });

    document.querySelectorAll('[data-creative-context]').forEach((element) => {
        element.addEventListener('change', () => {
            const form = element.form;
            if (!form) return;
            form.querySelectorAll('[name^="creative_"]').forEach((field) => {
                if (field !== element && field.name !== 'creative_currency') field.disabled = true;
            });
            if (element.dataset.creativeContext === 'country') {
                form.querySelector('[name="plan"]')?.setAttribute('disabled', 'disabled');
            }
            form.requestSubmit();
        });
    });

    document.querySelectorAll('[data-plan-picker]').forEach((picker) => {
        const search = picker.querySelector('[data-plan-search]');
        const count = picker.querySelector('[data-plan-count]');
        const checkboxes = [...picker.querySelectorAll('[data-plan-checkbox]')];
        const selectedArea = picker.querySelector('[data-selected-plans]');
        const optionsArea = picker.querySelector('[data-plan-options]');
        if (!search || checkboxes.length === 0) return;
        const selected = () => checkboxes.filter((checkbox) => checkbox.checked);
        const filter = () => {
            const term = search.value.trim().toLowerCase();
            checkboxes.forEach((checkbox) => {
                const option = checkbox.closest('[data-plan-option]');
                option.hidden = !(checkbox.checked || !term || option.dataset.searchValue.includes(term));
            });
        };
        const renderSelected = () => {
            const chosen = selected();
            if (selectedArea) {
                selectedArea.innerHTML = '';
                if (chosen.length === 0) {
                    const empty = document.createElement('span');
                    empty.className = 'px-2 py-1 text-xs font-semibold text-slate-400';
                    empty.textContent = 'No plans selected yet';
                    selectedArea.append(empty);
                }
                chosen.forEach((checkbox) => {
                    const chip = document.createElement('button');
                    chip.type = 'button';
                    chip.className = 'inline-flex max-w-full items-center gap-2 rounded-full bg-ink-950 px-3 py-1.5 text-left text-[11px] font-bold text-white';
                    const label = document.createElement('span');
                    label.className = 'truncate';
                    label.textContent = checkbox.dataset.planLabel;
                    const close = document.createElement('span');
                    close.textContent = '×';
                    close.setAttribute('aria-hidden', 'true');
                    chip.append(label, close);
                    chip.setAttribute('aria-label', `Remove ${checkbox.dataset.planLabel}`);
                    chip.addEventListener('click', () => {
                        checkbox.checked = false;
                        renderSelected();
                        filter();
                    });
                    selectedArea.append(chip);
                });
            }
            if (count) count.textContent = `${chosen.length} of 12 plans selected`;
        };
        search.addEventListener('input', filter);
        checkboxes.forEach((checkbox) => checkbox.addEventListener('change', () => {
            if (checkbox.checked && selected().length > 12) {
                checkbox.checked = false;
                window.alert('Choose up to 12 featured plans.');
            }
            if (checkbox.checked) optionsArea?.prepend(checkbox.closest('[data-plan-option]'));
            renderSelected();
            filter();
        }));
        renderSelected();
        filter();
    });

    document.querySelectorAll('[data-plan-select]').forEach((select) => {
        select.disabled = true;
        select.closest('[data-plan-picker]')?.setAttribute('hidden', 'hidden');
    });

    document.querySelectorAll('[data-plan-picker-legacy]').forEach((picker) => {
        const search = picker.querySelector('[data-plan-search]');
        const select = picker.querySelector('[data-plan-select]');
        const count = picker.querySelector('[data-plan-count]');
        if (!search || !select) return;
        const options = [...select.options];
        const filter = () => {
            const term = search.value.trim().toLowerCase();
            let matches = 0;
            options.forEach((option) => {
                const visible = option.selected || !term || option.textContent.toLowerCase().includes(term);
                option.hidden = !visible;
                option.style.display = visible ? '' : 'none';
                if (visible) matches += 1;
            });
            if (count) count.textContent = `${matches} matching plans · select up to 12`;
        };
        search.addEventListener('input', filter);
        select.addEventListener('change', filter);
    });

    document.querySelectorAll('[data-copy]').forEach((button) => {
        button.addEventListener('click', async () => {
            await navigator.clipboard.writeText(button.dataset.copy);
            const previous = button.textContent;
            button.textContent = 'Copied';
            window.setTimeout(() => { button.textContent = previous; }, 1600);
        });
    });

    document.querySelectorAll('[data-copy-target]').forEach((button) => {
        button.addEventListener('click', async () => {
            const target = document.getElementById(button.dataset.copyTarget);
            if (!target) return;
            await navigator.clipboard.writeText(target.value || target.textContent || '');
            const previous = button.textContent;
            button.textContent = 'Copied';
            window.setTimeout(() => { button.textContent = previous; }, 1600);
        });
    });

    document.querySelectorAll('[data-download-png]').forEach((button) => {
        button.addEventListener('click', async () => {
            const original = button.textContent;
            button.disabled = true;
            button.textContent = 'Preparing…';

            try {
                const response = await fetch(button.dataset.downloadPng, { headers: { Accept: 'image/svg+xml' } });
                if (!response.ok) throw new Error('The artwork could not be loaded.');
                const source = await response.text();
                const imageUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(source)}`;
                const image = new Image();
                await new Promise((resolve, reject) => {
                    image.onload = resolve;
                    image.onerror = () => reject(new Error('The artwork could not be converted by this browser.'));
                    image.src = imageUrl;
                });

                const canvas = document.createElement('canvas');
                canvas.width = image.naturalWidth;
                canvas.height = image.naturalHeight;
                const context = canvas.getContext('2d');
                if (!context) throw new Error('This browser does not support PNG export.');
                context.drawImage(image, 0, 0);
                const png = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png', 1));
                if (!png) throw new Error('This browser could not create the PNG.');

                const downloadUrl = URL.createObjectURL(png);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = button.dataset.filename || 'campaign-artwork.png';
                link.click();
                window.setTimeout(() => URL.revokeObjectURL(downloadUrl), 1000);
            } catch (error) {
                window.alert(error.message || 'The PNG could not be prepared. Download the SVG instead.');
            } finally {
                button.disabled = false;
                button.textContent = original;
            }
        });
    });

    document.querySelectorAll('[data-ajax-visibility]').forEach((form) => {
        form.addEventListener('submit', async (event) => {
            event.preventDefault();
            if (form.dataset.busy === 'true') return;

            const button = form.querySelector('button');
            const checkbox = form.querySelector('input[type="checkbox"]');
            const value = form.querySelector('input[name="visible"]');
            const label = form.querySelector('[data-visibility-label]');
            form.dataset.busy = 'true';
            button?.setAttribute('disabled', 'disabled');

            try {
                const response = await fetch(form.action, {
                    method: 'POST',
                    headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                    body: new FormData(form),
                });
                const result = await response.json();
                if (!response.ok) throw new Error(result.message || 'Could not update this plan.');

                checkbox.checked = Boolean(result.visible);
                value.value = result.visible ? '0' : '1';
                if (label) label.textContent = result.visible ? 'Visible' : 'Hidden';
                button?.setAttribute('aria-label', result.visible ? 'Hide plan' : 'Show plan');
                const normalizedStatus = form.closest('tr')?.querySelector('[data-normalized-status]');
                if (normalizedStatus) {
                    normalizedStatus.textContent = result.normalized_plan_active ? 'Available to buy' : 'Not for sale';
                    normalizedStatus.classList.toggle('text-emerald-600', result.normalized_plan_active);
                    normalizedStatus.classList.toggle('text-amber-600', !result.normalized_plan_active);
                }
            } catch (error) {
                window.alert(error.message);
            } finally {
                form.dataset.busy = 'false';
                button?.removeAttribute('disabled');
            }
        });
    });

    document.querySelectorAll('[data-plan-carousel]').forEach((carousel) => {
        const track = carousel.querySelector('[data-carousel-track]');
        const slides = [...track.querySelectorAll('.plan-carousel-slide')];
        let timer;
        const step = () => slides[0]?.getBoundingClientRect().width + 20 || track.clientWidth;
        const move = (direction = 1) => {
            const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 10;
            const atStart = track.scrollLeft <= 10;
            track.scrollTo({
                left: direction > 0 && atEnd ? 0 : direction < 0 && atStart ? track.scrollWidth : track.scrollLeft + step() * direction,
                behavior: 'smooth',
            });
        };
        const start = () => {
            window.clearInterval(timer);
            if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = window.setInterval(() => move(1), 6000);
        };
        carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => { move(1); start(); });
        carousel.querySelector('[data-carousel-prev]')?.addEventListener('click', () => { move(-1); start(); });
        carousel.addEventListener('mouseenter', () => window.clearInterval(timer));
        carousel.addEventListener('mouseleave', start);
        carousel.addEventListener('focusin', () => window.clearInterval(timer));
        carousel.addEventListener('focusout', start);
        start();
    });

    const assignmentQuote = document.querySelector('[data-assignment-quote]');
    if (assignmentQuote) {
        const plan = document.querySelector('[data-assignment-plan]');
        const fulfilment = document.querySelector('[data-assignment-fulfilment]');
        const renderQuote = () => {
            const cost = fulfilment.value === 'manual' ? 0 : Number(plan.selectedOptions[0]?.dataset.cost || NaN);
            const balance = Number(assignmentQuote.dataset.balance || NaN);
            const currency = assignmentQuote.dataset.currency;
            assignmentQuote.querySelector('[data-quote-cost]').textContent = Number.isFinite(cost) ? `${cost.toFixed(4)} ${currency}` : 'Choose a plan';
            assignmentQuote.querySelector('[data-quote-after]').textContent = Number.isFinite(cost) && Number.isFinite(balance) ? `${(balance - cost).toFixed(4)} ${currency}` : '—';
            assignmentQuote.classList.toggle('!border-red-200', Number.isFinite(cost) && Number.isFinite(balance) && cost > balance);
        };
        plan?.addEventListener('change', renderQuote);
        fulfilment?.addEventListener('change', renderQuote);
        renderQuote();
    }

    const mapNeeded = document.querySelector('[data-continent-map], [data-coverage-rotator]');
    let worldMap = { viewBox: '0 0 1010 666', locations: [] };
    if (mapNeeded) {
        try {
            worldMap = (await import('@svg-maps/world')).default;
        } catch {
            // Map loading is optional.
        }
    }

    document.querySelectorAll('[data-continent-map]').forEach((mount) => {
        const countryCodes = new Set(
            (mount.dataset.countryCodes || '')
                .split(',')
                .map((code) => code.trim().toLowerCase())
                .filter(Boolean)
        );
        const svgNamespace = 'http://www.w3.org/2000/svg';
        const svg = document.createElementNS(svgNamespace, 'svg');
        const group = document.createElementNS(svgNamespace, 'g');
        const paths = [];
        svg.setAttribute('viewBox', worldMap.viewBox);
        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');

        worldMap.locations
            .filter((location) => countryCodes.has(location.id))
            .forEach((location) => {
                const path = document.createElementNS(svgNamespace, 'path');
                path.setAttribute('d', location.path);
                path.dataset.countryId = location.id.toLowerCase();
                group.append(path);
                paths.push(path);
            });

        svg.append(group);
        mount.append(svg);

        window.requestAnimationFrame(() => {
            const focusCodes = new Set(
                (mount.dataset.focusCountryCodes || mount.dataset.countryCodes || '')
                    .split(',')
                    .map((code) => code.trim().toLowerCase())
                    .filter(Boolean)
            );
            const focusPaths = paths.filter((path) => focusCodes.has(path.dataset.countryId));
            const boxes = (focusPaths.length ? focusPaths : paths)
                .map((path) => path.getBBox())
                .filter((box) => box.width && box.height);
            if (!boxes.length) {
                return;
            }

            const left = Math.min(...boxes.map((box) => box.x));
            const top = Math.min(...boxes.map((box) => box.y));
            const right = Math.max(...boxes.map((box) => box.x + box.width));
            const bottom = Math.max(...boxes.map((box) => box.y + box.height));
            const width = right - left;
            const height = bottom - top;
            const padding = Math.max(width, height) * 0.08;
            svg.setAttribute('viewBox', [
                left - padding,
                top - padding,
                width + (padding * 2),
                height + (padding * 2),
            ].join(' '));
        });
    });

    const coverage = document.querySelector('[data-coverage-rotator]');
    if (coverage) {
        const payload = coverage.querySelector('[data-coverage-data]');
        const flags = [...coverage.querySelectorAll('[data-coverage-flag]')];
        const controls = [...coverage.querySelectorAll('[data-coverage-region]')];
        const mapMount = coverage.querySelector('[data-coverage-world-map]');
        const exploreLink = coverage.querySelector('[data-coverage-link]');
        const marker = coverage.querySelector('[data-coverage-marker]');
        const markerLabel = coverage.querySelector('[data-coverage-marker-label]');
        const svgNamespace = 'http://www.w3.org/2000/svg';
        let mapPaths = [];
        let regions = [];
        let activeRegion = 0;
        let timer;

        try {
            regions = JSON.parse(payload?.textContent || '[]');
        } catch {
            regions = [];
        }

        if (mapMount) {
            const svg = document.createElementNS(svgNamespace, 'svg');
            svg.classList.add('coverage-world-svg');
            svg.setAttribute('viewBox', worldMap.viewBox);
            svg.setAttribute('role', 'presentation');
            svg.setAttribute('focusable', 'false');

            worldMap.locations.forEach((location) => {
                const path = document.createElementNS(svgNamespace, 'path');
                path.setAttribute('d', location.path);
                path.dataset.countryId = location.id;
                svg.append(path);
            });

            mapMount.append(svg);
            mapPaths = [...svg.querySelectorAll('path')];
        }

        const updateMap = (region) => {
            const activeCountries = new Set(
                (region.mapCountries || region.countries.map(([code]) => code))
                    .map((code) => code.toLowerCase())
            );
            mapPaths.forEach((path) => {
                path.classList.toggle('is-active', activeCountries.has(path.dataset.countryId));
            });

            marker?.style.setProperty('--marker-x', `${region.marker[0]}%`);
            marker?.style.setProperty('--marker-y', `${region.marker[1]}%`);
            if (markerLabel) markerLabel.textContent = region.name;
        };

        const renderRegion = (index) => {
            if (!regions[index] || index === activeRegion && coverage.dataset.coverageReady === 'true') return;
            activeRegion = index;
            coverage.dataset.coverageReady = 'true';
            coverage.classList.add('is-switching');

            window.setTimeout(() => {
                coverage.querySelector('[data-coverage-continent]').textContent = regions[index].name;
                coverage.querySelector('[data-coverage-subtitle]').textContent = regions[index].subtitle;
                if (exploreLink) {
                    exploreLink.href = regions[index].url;
                    exploreLink.setAttribute('aria-label', `Explore ${regions[index].name}`);
                }
                updateMap(regions[index]);
                flags.forEach((flag, flagIndex) => {
                    const [code, label] = regions[index].countries[flagIndex];
                    const icon = flag.querySelector('.fi');
                    [...icon.classList].filter((name) => /^fi-[a-z]{2}$/.test(name)).forEach((name) => icon.classList.remove(name));
                    icon.classList.add(`fi-${code}`);
                    icon.setAttribute('aria-label', label);
                    flag.querySelector('[data-coverage-label]').textContent = label;
                });
                controls.forEach((control, controlIndex) => {
                    const selected = controlIndex === index;
                    control.classList.toggle('active', selected);
                    control.setAttribute('aria-pressed', String(selected));
                });
                coverage.classList.remove('is-switching');
            }, 220);
        };

        const restart = () => {
            window.clearInterval(timer);
            if (regions.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                timer = window.setInterval(() => renderRegion((activeRegion + 1) % regions.length), 6000);
            }
        };

        controls.forEach((control) => control.addEventListener('click', () => {
            renderRegion(Number(control.dataset.coverageRegion));
            restart();
        }));
        if (regions[0]) updateMap(regions[0]);
        coverage.dataset.coverageReady = 'true';
        restart();
    }
});
